// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.termsPage {
  background: #F6F8FC;
}

.termsHero {
  padding: 90px 20px;
  background: linear-gradient(135deg, #04b0fab4, rgba(44,116,250,0.85));
  color: white;
  text-align: center;
}

.termsHero h1 {
  font-size: 42px;
  margin-bottom: 10px;
}


.termsContent {
  padding: 70px 20px 100px;
}


.narrow {
  max-width: 850px;
}

.termsContent h2 {
  margin-top: 40px;
  margin-bottom: 16px;
  font-size: 24px;
  color: #0D1B2A;
}

.termsContent p {
  margin-bottom: 16px;
  line-height: 1.7;
  color: #333;
}

.termsContent ul {
  margin-left: 20px;
  margin-bottom: 20px;
}

.termsContent li {
  margin-bottom: 8px;
}

.acknowledgment {
  margin-top: 40px;
  font-weight: 600;
  padding-top: 20px;
  border-top: 1px solid #ddd;
}
`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/Terms.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qEAAqE;EACrE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B","sourcesContent":[".termsPage {\n  background: #F6F8FC;\n}\n\n.termsHero {\n  padding: 90px 20px;\n  background: linear-gradient(135deg, #04b0fab4, rgba(44,116,250,0.85));\n  color: white;\n  text-align: center;\n}\n\n.termsHero h1 {\n  font-size: 42px;\n  margin-bottom: 10px;\n}\n\n\n.termsContent {\n  padding: 70px 20px 100px;\n}\n\n\n.narrow {\n  max-width: 850px;\n}\n\n.termsContent h2 {\n  margin-top: 40px;\n  margin-bottom: 16px;\n  font-size: 24px;\n  color: #0D1B2A;\n}\n\n.termsContent p {\n  margin-bottom: 16px;\n  line-height: 1.7;\n  color: #333;\n}\n\n.termsContent ul {\n  margin-left: 20px;\n  margin-bottom: 20px;\n}\n\n.termsContent li {\n  margin-bottom: 8px;\n}\n\n.acknowledgment {\n  margin-top: 40px;\n  font-weight: 600;\n  padding-top: 20px;\n  border-top: 1px solid #ddd;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
